var map = {
	"./da.json": [
		3517,
		798
	],
	"./de.json": [
		5993,
		706
	],
	"./en.json": [
		1885,
		990
	],
	"./es.json": [
		6870,
		69
	],
	"./fr.json": [
		6814,
		261
	],
	"./id.json": [
		9687,
		236
	],
	"./it.json": [
		1735,
		996
	],
	"./ja.json": [
		2339,
		368
	],
	"./ko.json": [
		3844,
		455
	],
	"./nl.json": [
		6288,
		243
	],
	"./pl.json": [
		4810,
		713
	],
	"./pt.json": [
		4594,
		321
	],
	"./ru.json": [
		4951,
		572
	],
	"./sv.json": [
		8567,
		500
	],
	"./ta.json": [
		4301,
		126
	],
	"./zh-Hans.json": [
		9375,
		676
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5793;
module.exports = webpackAsyncContext;